import TrashLineIcon from "remixicon-react/DeleteBin2LineIcon";
import { useCallback, useState } from "react";
import { FormHeader } from "$components/Forms/FormHeader";
import UserForm from "./UserForm";
import useAuth from "$hooks/useAuth";
import JModal from "$components/JModal/JModal";
import useUserForm from "$hooks/useUserForm";
import { COORDINATOR_JOB } from "$utils/typeConstants";
import { DeleteUser } from "$services/Coordinators.service";

export const CoordinatorPopin = ({ togglePopin, user, setUser }: any) => {
  const { token, isAdmin } = useAuth();
  const [modalActive, setModalActive] = useState<boolean>(false);

  const title = user?._id
    ? "Édition de la fiche Coordinateur Logistique"
    : "Ajouter un Coordinateur Logistique";

  const { onSubmit, onSubmitEdit } = useUserForm();

  const handleOnSubmit = useCallback(
    async (data: any) => {
      if (user) {
        await onSubmitEdit(data);
      } else {
        await onSubmit({
          ...data,
          job: COORDINATOR_JOB,
          isOnlyContact: false,
        });
      }
      setModalActive(false);
      togglePopin();
    },
    [onSubmit, onSubmitEdit, togglePopin, user]
  );

  const handleDeleteUser = useCallback(async () => {
    await DeleteUser(token, user?._id);
    setModalActive(false);
    togglePopin();
  }, [togglePopin, token, user]);

  return (
    <>
      <FormHeader
        title={title}
        icon={user && isAdmin() ? <TrashLineIcon /> : undefined}
        onClick={() => setModalActive(true)}
      />

      <UserForm
        hasToBeUser
        user={user}
        onSubmit={handleOnSubmit}
        onReset={() => {
          setUser();
          togglePopin();
        }}
      />
      {modalActive && (
        <JModal
          message={`Êtes vous sur de vouloir supprimer l'utilisateur : ${user.lastname} ${user.firstname} (${user.email})`}
          labelOk="Supprimer"
          labelCancel="Annuler"
          onConfirm={handleDeleteUser}
          onClose={() => setModalActive(false)}
        />
      )}
    </>
  );
};
